import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonText } from '@ionic/angular/standalone';
import { PuzzleWinDialogInjectableInterface } from '../../shared-module/puzzle-win-dialog/puzzle-win-dialog-injectable.interface';
import { PuzzleGameState } from '../../store/puzzle-game.state';
import { map } from 'rxjs/operators';
import { PuzzleGameModel } from '../../store/puzzle-game.model';
import { PuzzleTimeRecordState } from '../../store/puzzle-time-record.state';
import { PuzzleTimeRecordModel } from '../../store/puzzle-time-record.model';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { PuzzleWinDialogService } from '../../shared-module/puzzle-win-dialog/puzzle-win-dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { PuzzleSolutionWordAnimationComponent } from 'projects/tools/src/lib/shared-module/puzzle-solution-word-animation/puzzle-solution-word-animation.component';
import { TranslateModule } from '@ngx-translate/core';

const SOLUTION_ANIMATION_TIMEOUT = 50;

@Component({
  selector: 'lib-app-word-search-puzzle-win-screen',
  templateUrl: './word-search-puzzle-win-screen.component.html',
  styleUrls: ['./word-search-puzzle-win-screen.component.scss'],
  standalone: true,
  imports: [CommonModule, IonText, PuzzleSolutionWordAnimationComponent, TranslateModule],
})
export class WordSearchPuzzleWinScreenComponent implements PuzzleWinDialogInjectableInterface, OnDestroy {
  data: {
    solutionWord?: string;
    solutionOriginal?: string;
    hasSolutionWord: boolean;
  };

  moveCounter: number;
  duration: string;
  showOriginal: boolean;
  translationKey: string;

  private puzzleGameSubscription: Subscription;
  private timeRecordSubscription: Subscription;

  constructor(
    private store: Store,
    private framework: PuzzleFrameworkService,
    private winScreenService: PuzzleWinDialogService,
    private translateService: TranslateService
  ) {
    this.store
      .select((state) => state.puzzleID)
      .subscribe((puzzleID) => {
        this.puzzleGameSubscription = this.store
          .select(PuzzleGameState.getByID(puzzleID))
          .subscribe((puzzleGame: PuzzleGameModel) => {
            this.moveCounter = puzzleGame.moveCounter;
          });
        this.timeRecordSubscription = this.store
          .select(PuzzleTimeRecordState.getTimeRecordByID)
          .pipe(map((filterFn) => filterFn(puzzleID)))
          .subscribe((timeRecord: PuzzleTimeRecordModel) => {
            this.duration = timeRecord.timeRecord.timeString;
          });
      });

    this.translationKey = this.framework.getTranslationKey();
    this.translateService
      .get(this.translationKey + '.win_dialog.title')
      .toPromise()
      .then((title) => {
        this.winScreenService.setTitle(title);
      });
  }

  ngOnDestroy(): void {
    this.puzzleGameSubscription.unsubscribe();
    this.timeRecordSubscription.unsubscribe();
  }

  public setData(data: any) {
    this.data = data;
  }
}
